export default __webpack_public_path__ + "static/media/algoColR2.739b3fb2.svg";